import Navara from "../images/cars-big/nissannavara.webp";
import Veloz from "../images/cars-big/ToyotaVeloz.png";
import XL7 from "../images/cars-big/WHITE-ALPHA.webp";
import Beat from "../images/cars-big/BEAT-110-PREMIUM-1.png";

export const CAR_DATA = [
  {
    name: "Nissan Navara",
    price: 2800,
    rates: {
      "1 Day Within City": 2800,
      "1 Day Outside City": 3500,
      "More than 1 Day Within City": 2500,
      "More than 1 Day Outside City": 2800,
      "1-2 Weeks Rent In and Out of the City": 2500,
      "More than 2 Weeks": 2000,
    },
    carwashfee: 300,
    img: Navara,
    model: "Navara",
    mark: "5-seater",
    year: "2024",
    doors: "4/5",
    air: "Yes",
    transmission: "Automatic",
    fuel: "Diesel",
    owner: "Ronald",
    plate: "ASDF 7264",
  },
  {
    name: "Toyota Veloz",
    price: 2500,
    rates: {
      "1 Day Within City": 2500,
      "1 Day Outside City": 2800,
      "More than 1 Day Within City": 2300,
      "More than 1 Day Outside City": 2500,
      "1-2 Weeks Rent In and Out of the City": 2100,
      "More than 2 Weeks": 2000,
    },
    carwashfee: 300,
    img: Veloz,
    model: "Veloz Premium",
    mark: "7-seater",
    year: "2024",
    doors: "4/5",
    air: "Yes",
    transmission: "Automatic",
    fuel: "Gasoline",
    owner: "Ronald",
    plate: "ASDF 7263",
  },
  {
    name: "Suzuki XL7 Hybrid",
    price: 2800,
    rates: {
      "1 Day Within City": 2800,
      "1 Day Outside City": 3300,
      "More than 1 Day Within City": 2800,
      "More than 1 Day Outside City": 3000,
      "1-2 Weeks Rent In and Out of the City": 2500,
      "More than 2 Weeks": 2100,
    },
    carwashfee: 300,
    img: XL7,
    model: "XL7",
    mark: "7-seater",
    year: "2025",
    doors: "4/5",
    air: "Yes",
    transmission: "Automatic",
    fuel: "Gasoline",
    owner: "Ronald",
    plate: "ASDF 7262",
  },
  {
    name: "Honda Beat V2",
    price: 400,
    rates: {
      "1 Day Within City": 400,
      "1 Day Outside City": 500,
      "More than 1 Day Within City": 350,
      "More than 1 Day Outside City": 400,
      "1-2 Weeks Rent In and Out of the City": 350,
      "More than 2 Weeks": 300,
    },
    carwashfee: 150,
    img: Beat,
    model: "Beat V2 Premium",
    mark: "Motorcycle",
    year: "2023",
    doors: "N/A",
    air: "No",
    transmission: "Automatic",
    fuel: "Gasoline",
    owner: "Ronald",
    plate: "ASDF 7261",
  },
];

export const CAR_DATA_JSON = {
  "ASDF 7264": CAR_DATA[0], //Navara
  "ASDF 7263": CAR_DATA[1], //Veloz
  "ASDF 7262": CAR_DATA[2], //XL7
  "ASDF 7261": CAR_DATA[3], //Beat
}


export const COLUMN_HEADER_PRICING = [
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    //render: (text) => <a>{text}</a>,
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.location > b.location,
    sortDirections: ['ascend','descend'],
  },
  {
    title: 'Destination',
    dataIndex: 'name',
    key: 'destination',
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.name > b.name,
    sortDirections: ['ascend','descend'],
  },
  {
    title: 'Distance/Duration',
    dataIndex: 'distance/duration',
    key: 'dist/dur',
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a['distance/duration'] > b['distance/duration'],
    sortDirections: ['ascend','descend'],
  },
  {
    title: '1-3 Pax',
    dataIndex: 'rates',
    key: 'rateslowcap',
    render: (_, { rates }) => (
      <>
      {rates.lowcap}
      </>
    ),
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.rates.lowcap > b.rates.lowcap,
    sortDirections: ['ascend','descend'],
  },
  {
    title: '4-6 Pax',
    dataIndex: 'rates',
    key: 'ratesmedcap',
    render: (_, { rates }) => (
      <>
      {rates.medcap}
      </>
    ),
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.rates.medcap > b.rates.medcap,
    sortDirections: ['ascend','descend'],
  },
  {
    title: '7+ Pax',
    dataIndex: 'rates',
    key: 'rateshighcap',
    render: (_, { rates }) => (
      <>
      {rates.highcap}
      </>
    ),
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.rates.highcap > b.rates.highcap,
    sortDirections: ['ascend','descend'],
  },
  // {
  //   title: 'Tags',
  //   key: 'tags',
  //   dataIndex: 'tags',
  //   render: (_, { tags }) => (
  //     <>
  //       {tags.map((tag) => {
  //         let color = tag.length > 5 ? 'geekblue' : 'green';
  //         if (tag === 'loser') {
  //           color = 'volcano';
  //         }
  //         return (
  //           <Tag color={color} key={tag}>
  //             {tag.toUpperCase()}
  //           </Tag>
  //         );
  //       })}
  //     </>
  //   ),
  // },
  // {
  //   title: 'Action',
  //   key: 'action',
  //   render: (_, record) => (
  //     <Space size="middle">
  //       <a>Invite {record.name}</a>
  //       <a>Delete</a>
  //     </Space>
  //   ),
  // },
]


export const DESTINATIONS = [
  {
    key: "1PaxCityTour",
    name:"City Tour [1 Pax only - Motor with driver]",
    location: "Central Palawan",
    "distance/duration": "4 hours",
    rates: {
      "lowcap" : 500,
      "medcap" : "-",
      "highcap" : "-",
    }
  },
  {
    key: "Min3CityTour",
    name:"City Tour [Minimum of 3 Pax - Private Car]",
    location: "Central Palawan",
    "distance/duration": "4 hours",
    rates: {
      "lowcap" : 2400,
      "medcap" : 4800,
      "highcap" : 5600,
    }
  },
  {
    key: "1PaxNagtabon",
    name:"Nagtabon Beach [1 Pax only - Motor with driver]",
    location: "Central Palawan",
    "distance/duration": "4 hours",
    rates: {
      "lowcap" : 800,
      "medcap" : "-",
      "highcap" : "-",
    }
  },
  {
    key: "Nagtabon",
    name:"Nagtabon Beach [Private Car]",
    location: "Central Palawan",
    "distance/duration": "75 km",
    rates: {
      "lowcap" : 2500,
      "medcap" : 3000,
      "highcap" : 3500,
    }
  },
  {
    key: "Sabang",
    name:"Sabang (Underground River)",
    location: "Northern Palawan",
    "distance/duration": "75 km",
    rates: {
      "lowcap" : 3000,
      "medcap" : 5000,
      "highcap" : 6000,
    }
  },
  {
    key: "ElNido",
    name:"El Nido",
    location: "Northern Palawan",
    "distance/duration": "260 km",
    rates: {
      "lowcap" : 6500,
      "medcap" : 8500,
      "highcap" : 9500,
    }
  },
  {
    key: "PortBarton",
    name:"Port Barton",
    location: "Northern Palawan",
    "distance/duration": "160 km",
    rates: {
      "lowcap" : 4500,
      "medcap" : 6500,
      "highcap" : 7500,
    }
  },
  {
    key: "Roxas",
    name:"Roxas",
    location: "Northern Palawan",
    "distance/duration": "130 km",
    rates: {
      "lowcap" : 4000,
      "medcap" : 5500,
      "highcap" : 6500,
    }
  },
  {
    key: "TayTay",
    name:"TayTay",
    location: "Northern Palawan",
    "distance/duration": "220 km",
    rates: {
      "lowcap" : 5500,
      "medcap" : 7500,
      "highcap" : 8500,
    }
  },
  {
    key: "SanVicente",
    name:"San Vicente (Long Beach)",
    location: "Northern Palawan",
    "distance/duration": "186 km",
    rates: {
      "lowcap" : 5800,
      "medcap" : 6800,
      "highcap" : 7800,
    }
  },
  {
    key: "Narra",
    name:"Narra",
    location: "Southern Palawan",
    "distance/duration": "90 km",
    rates: {
      "lowcap" : 3000,
      "medcap" : 4500,
      "highcap" : 5500,
    }
  },
  {
    key: "BrookesPoint",
    name:"Brooke's Point",
    location: "Southern Palawan",
    "distance/duration": "190 km",
    rates: {
      "lowcap" : 5000,
      "medcap" : 7000,
      "highcap" : 8000,
    }
  },
  {
    key: "HondaBay",
    name:"Honda Bay / Sta. Lourdes Wharf",
    location: "Southern Palawan",
    "distance/duration": "15 km",
    rates: {
      "lowcap" : 1800,
      "medcap" : 3500,
      "highcap" : 4500,
    }
  },
  {
    key: "Bataraza",
    name:"Bataraza / Rio Tuba",
    location: "Southern Palawan",
    "distance/duration": "280 km",
    rates: {
      "lowcap" : 8000,
      "medcap" : 9500,
      "highcap" : 10500,
    }
  },
  {
    key: "BuliluyanPort",
    name:"Buliluyan Port",
    location: "Southern Palawan",    
    "distance/duration": "310 km",
    rates: {
      "lowcap" : 9000,
      "medcap" : 10500,
      "highcap" : 11500,
    }
  },
]

export const RATE_NAMES = [
  { id: "lowcap", name: "1-3 Pax"},
  { id: "medcap", name: "4-6 Pax"},  
  { id: "highcap", name: "more than 7 Pax"}
]

export const COLUMN_HEADER_VEHICLES = [
  {
    title: 'Vehicle',
    dataIndex: 'name',
    key: 'name',
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.name > b.name,
    sortDirections: ['ascend','descend'],
  },
  {
    title: 'Type',
    dataIndex: 'vehicletype',
    key: 'type',
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.vehicletype > b.vehicletype,
    sortDirections: ['ascend','descend'],
  },
  {
    title: 'Model',
    dataIndex: 'model',
    key: 'model',
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.model > b.model,
    sortDirections: ['ascend','descend'],
  },
  {
    title: '12 Hrs',
    dataIndex: 'rates',
    key: 'rates12hrs',
    render: (_, { rates }) => (
      <>
      {rates.halfday}
      </>
    ),
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.rates.halfday > b.rates.halfday,
    sortDirections: ['ascend','descend'],
  },
  {
    title: 'Daily',
    dataIndex: 'rates',
    key: 'rates1day',
    render: (_, { rates }) => (
      <>
      {rates.daily}
      </>
    ),
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.rates.daily > b.rates.daily,
    sortDirections: ['ascend','descend'],
  },
  {
    title: 'Weekly',
    dataIndex: 'rates',
    key: 'rates1week',
    render: (_, { rates }) => (
      <>
      {rates.weekly}
      </>
    ),
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.rates.weekly > b.rates.weekly,
    sortDirections: ['ascend','descend'],
  },   
  {
    title: 'Monthly',
    dataIndex: 'rates',
    key: 'rates1month',
    render: (_, { rates }) => (
      <>
      {rates.monthly}
      </>
    ),
    showSorterTooltip: {
      target: 'full-header',
    },
    sorter: (a, b) => a.rates.monthly > b.rates.monthly,
    sortDirections: ['ascend','descend'],
  }, 
]


export const VEHICLE_DATA = [
  {
    name: "Nissan Navara",
    vehicletype: "Pick-Up",
    model: "Navara VE 4x2 Calibre",
    plate: "ASDF 7264",
    rates: {
      "halfday": 4000,
      "daily": 4000,
      "weekly": 24000,
      "monthly": 70000,
    },
    carwashfee: 200,
    driverfee: 800,
    adminfee: 200,
  },
  {
    name: "Toyota Veloz",
    vehicletype: "7-seater SUV",
    model: "Veloz VE (Premium)",
    plate: "ASDF 7263",
    rates: {
      "halfday": 1500,
      "daily": 2800,
      "weekly": 16000,
      "monthly": 50000,
    },
    carwashfee: 200,
    driverfee: 800,
    adminfee: 200,
  },
  {
    name: "Suzuki XL7",
    vehicletype: "7-seater SUV",
    model: "XL7 Hybrid",
    plate: "ASDF 7262",
    rates: {
      "halfday": 1500,
      "daily": 2800,
      "weekly": 16000,
      "monthly": 50000,
    },
    carwashfee: 200,
    driverfee: 800,
    adminfee: 200,
  },
  {
    name: "Toyota Wigo",
    vehicletype: "5-seater Sedan",
    model: "Wigo",
    plate: "ASDF 7259",
    rates: {
      "halfday": 1000,
      "daily": 1500,
      "weekly": 9000,
      "monthly": 30000,
    },
    carwashfee: 200,
    driverfee: 800,
    adminfee: 200,
  },
  {
    name: "Toyota Vios",
    vehicletype: "5-seater Sedan",
    model: "Vios",
    plate: "ASDF 7260",
    rates: {
      "halfday": 1000,
      "daily": 1500,
      "weekly": 9000,
      "monthly": 30000,
    },
    carwashfee: 200,
    driverfee: 800,
    adminfee: 200,
  },
  {
    name: "Mitshubishi Mirage",
    vehicletype: "5-seater Sedan",
    model: "Mirage G4",
    plate: "ASDF 7260",
    rates: {
      "halfday": 1000,
      "daily": 1500,
      "weekly": 9000,
      "monthly": 30000,
    },
    carwashfee: 200,
    driverfee: 800,
    adminfee: 200,
  },
  {
    name: "Honda Beat",
    vehicletype: "2-seater Motorcycle",
    model: "Beat V2 Premium",
    plate: "ASDF 7261",
    rates: {
      "halfday": 550,
      "daily": 500,
      "weekly": 2800,
      "monthly": 11400,
    },
    carwashfee: 200,
    driverfee: 800,
    adminfee: 100,
  },
]